import axios from '@/axios';

export async function getCart() {
    const response = await axios.get('/api/dealer/cart');
    if (!response.data.success) throw new Error(response.data.error || 'Failed to fetch cart');
    return response.data.data.items;
}

export async function putCart(items) {
    const response = await axios.put('/api/dealer/cart', { items });
    if (!response.data.success) throw new Error(response.data.error || 'Failed to save cart');
    return response.data.data.items;
}
